module.exports = __webpack_public_path__ + "img/x431_2.075b2148.jpg";